import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
import { useVuexStore } from '@/plugins/app-context';
import { ROUTE_PATHS } from '@/shared/constants';
export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderProfileDropdown',
  emits: ["dropdown-item-click"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    defineComponent({
      name: 'HeaderProfileDropdown'
    });
    function onLogoutClick() {
      useVuexStore().$auth.logout();
      emit('dropdown-item-click');
    }
    return {
      __sfc: true,
      emit: emit,
      onLogoutClick: onLogoutClick,
      SIcon: SIcon,
      ROUTE_PATHS: ROUTE_PATHS
    };
  }
});